/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _toConsumableArray } from '../_chunks/dep-fd3498b6.js';
import React from 'react';
import Tree from '../tree/Tree.js';
import Upload from '../upload/upload.js';
import CheckTag from '../tag/CheckTag.js';
import { C as Checkbox, a as CheckboxGroup } from '../_chunks/dep-e3db8410.js';
import TagInput from '../tag-input/TagInput.js';
import RangeInput from '../range-input/RangeInput.js';
import Transfer from '../transfer/Transfer.js';
import DateRangePicker from '../date-picker/DateRangePicker.js';
import TimeRangePicker from '../time-picker/TimeRangePicker.js';
import '../_chunks/dep-2acfafca.js';
import '../_chunks/dep-46de7b2e.js';
import '../_chunks/dep-e43cf21c.js';
import 'react-transition-group';
import 'classnames';
import '../_util/usePersistFn.js';
import '../tree/useTreeConfig.js';
import '../hooks/useConfig.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-f10515e8.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-88cd50bf.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-7dce2c26.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../locale/LocalReceiver.js';
import '../config-provider/index.js';
import '../config-provider/ConfigProvider.js';
import '../tree/useControllable.js';
import '../hooks/useControlled.js';
import '../_chunks/dep-f721d103.js';
import '../_chunks/dep-4559db64.js';
import '../_chunks/dep-c00532d4.js';
import '../_chunks/dep-33ffecad.js';
import '../_chunks/dep-c1f93350.js';
import '../_util/noop.js';
import '../tree/TreeItem.js';
import 'tdesign-icons-react';
import '../loading/index.js';
import '../loading/Loading.js';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-6c5254c6.js';
import '../_util/easing.js';
import '../common/Portal.js';
import 'react-dom';
import '../loading/gradient.js';
import '../hooks/useDomRefCallback.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-92728dc5.js';
import '../_chunks/dep-ec16db36.js';
import '../_chunks/dep-036ad2cc.js';
import '../_chunks/dep-0e15088f.js';
import '../loading/defaultProps.js';
import '../loading/plugin.js';
import '../_util/react-render.js';
import '../_chunks/dep-e0370ebe.js';
import '../loading/style/css.js';
import '../loading/type.js';
import '../_util/useRipple.js';
import '../_util/useAnimation.js';
import '../_util/setStyle.js';
import '../hooks/useGlobalIcon.js';
import '../checkbox/index.js';
import '../checkbox/style/css.js';
import '../checkbox/type.js';
import '../_util/forwardRefWithStatics.js';
import 'hoist-non-react-statics';
import '../common/Check.js';
import '../_chunks/dep-7dad86aa.js';
import '../_util/helper.js';
import '../_chunks/dep-2ffb6f37.js';
import '../_chunks/dep-08c1f545.js';
import '../checkbox/defaultProps.js';
import '../tree/useDraggable.js';
import '../_chunks/dep-b0a01ce1.js';
import '../_chunks/dep-01ce608f.js';
import '../_chunks/dep-77a54538.js';
import '../tree/TreeDraggableContext.js';
import '../_util/createHookContext.js';
import '../_util/composeRefs.js';
import '../tree/useStore.js';
import '../_chunks/dep-0bc19feb.js';
import '../_chunks/dep-09050977.js';
import '../_chunks/dep-23d0a0bb.js';
import '../_chunks/dep-c8399d32.js';
import '../_util/useUpdateEffect.js';
import '../_util/useLayoutEffect.js';
import '../_common/js/tree/tree-store.js';
import '../_chunks/dep-e51b1270.js';
import '../_chunks/dep-1cec561b.js';
import '../_chunks/dep-7004b0d9.js';
import '../_chunks/dep-e73d1b75.js';
import 'mitt';
import '../_common/js/tree/tree-node.js';
import '../_chunks/dep-a827ffec.js';
import '../_chunks/dep-337b4140.js';
import '../_chunks/dep-ca64038e.js';
import '../_common/js/tree/tree-node-model.js';
import '../_chunks/dep-4f1e1217.js';
import '../_chunks/dep-29cb89ad.js';
import '../_chunks/dep-7b67cdbf.js';
import '../_common/js/log/log.js';
import '../_common/js/log/index.js';
import '../_util/parseTNode.js';
import '../upload/themes/NormalFile.js';
import '../link/index.js';
import '../link/Link.js';
import '../link/style/css.js';
import '../_common/js/upload/utils.js';
import '../upload/themes/DraggerFile.js';
import '../hooks/useCommonClassName.js';
import '../upload/hooks/useDrag.js';
import '../image-viewer/index.js';
import '../image-viewer/ImageViewer.js';
import '../_chunks/dep-10388ab5.js';
import '../tooltip/index.js';
import '../tooltip/Tooltip.js';
import '../popup/index.js';
import '../popup/Popup.js';
import 'react-popper';
import '../hooks/usePrevious.js';
import '../popup/hooks/useTrigger.js';
import 'react-is';
import '../popup/utils/ref.js';
import '../popup/utils/transition.js';
import '../_util/useMutationObserver.js';
import '../_util/useWindowSize.js';
import '../popup/defaultProps.js';
import '../popup/style/css.js';
import '../popup/type.js';
import '../tooltip/defaultProps.js';
import '../tooltip/TooltipLite.js';
import '../_util/useSwitch.js';
import '../_common/js/utils/getPosition.js';
import '../tooltip/style/css.js';
import '../tooltip/type.js';
import '../image-viewer/utils.js';
import '../dialog/index.js';
import '../dialog/Dialog.js';
import '../_util/useSetState.js';
import '../dialog/defaultProps.js';
import '../dialog/DialogCard.js';
import '../button/index.js';
import '../button/Button.js';
import '../button/defaultProps.js';
import '../button/style/css.js';
import '../button/type.js';
import '../dialog/hooks/useDialogEsc.js';
import '../dialog/hooks/useLockStyle.js';
import '../_common/js/utils/getScrollbarWidth.js';
import '../dialog/hooks/useDialogPosition.js';
import '../dialog/hooks/useDialogDrag.js';
import '../dialog/utils.js';
import '../dialog/plugin.js';
import '../dialog/style/css.js';
import '../dialog/type.js';
import '../image-viewer/hooks/useMirror.js';
import '../image-viewer/hooks/usePosition.js';
import '../image-viewer/hooks/useIndex.js';
import '../image-viewer/hooks/useRotate.js';
import '../image-viewer/hooks/useScale.js';
import '../image-viewer/hooks/useIconMap.js';
import '../image-viewer/defaultProps.js';
import '../image-viewer/hooks/useImageScale.js';
import '../image-viewer/hooks/useList.js';
import '../image-viewer/hooks/useViewerScale.js';
import '../image-viewer/style/css.js';
import '../upload/themes/ImageCard.js';
import '../upload/themes/MultipleFlowList.js';
import '../upload/hooks/useUpload.js';
import '../_common/js/upload/main.js';
import '../_common/js/upload/xhr.js';
import '../upload/defaultProps.js';
import '../upload/themes/CustomFile.js';
import '../tag/defaultProps.js';
import '../_util/useDragSorter.js';
import '../input/index.js';
import '../input/Input.js';
import '../input/InputGroup.js';
import '../input/defaultProps.js';
import '../input/useLengthLimit.js';
import '../input/style/css.js';
import '../input/type.js';
import '../tag-input/useTagScroll.js';
import '../tag-input/useTagList.js';
import '../tag/index.js';
import '../tag/Tag.js';
import '../tag/style/css.js';
import '../tag/type.js';
import '../tag-input/useHover.js';
import '../tag-input/defaultProps.js';
import '../range-input/defaultProps.js';
import '../transfer/TransferList.js';
import '../_chunks/dep-64a9d67c.js';
import '../transfer/utils.js';
import '../pagination/index.js';
import '../pagination/Pagination.js';
import '../select/index.js';
import '../select/base/Select.js';
import '../select/util/helper.js';
import '../select/base/OptionGroup.js';
import '../select/defaultProps.js';
import '../select/base/Option.js';
import '../common/FakeArrow.js';
import '../select-input/index.js';
import '../select-input/SelectInput.js';
import '../select-input/useSingle.js';
import '../select-input/useMultiple.js';
import '../tag-input/index.js';
import '../tag-input/style/css.js';
import '../tag-input/type.js';
import '../select-input/useOverlayInnerStyle.js';
import '../select-input/defaultProps.js';
import '../select-input/style/css.js';
import '../select-input/type.js';
import '../select/base/PopupContent.js';
import '../select/hooks/usePanelVirtualScroll.js';
import '../hooks/useVirtualScroll.js';
import '../hooks/useResizeObserver.js';
import '../select/hooks/useOptions.js';
import '../select/style/css.js';
import '../select/type.js';
import '../input-number/index.js';
import '../input-number/InputNumber.js';
import '../input-number/useInputNumber.js';
import '../_util/useCommonClassName.js';
import '../_common/js/input-number/number.js';
import '../_common/js/input-number/large-number.js';
import '../input-number/defaultProps.js';
import '../input-number/style/css.js';
import '../input-number/type.js';
import '../input-adornment/index.js';
import '../input-adornment/InputAdornment.js';
import '../input-adornment/style/css.js';
import '../input-adornment/type.js';
import '../pagination/hooks/useBoundaryJumper.js';
import '../pagination/hooks/usePrevNextJumper.js';
import '../pagination/hooks/usePageNumber.js';
import '../pagination/hooks/useTotal.js';
import '../pagination/validators.js';
import '../pagination/defaultProps.js';
import '../pagination/PaginationMini.js';
import '../pagination/style/css.js';
import '../pagination/type.js';
import '../transfer/defaultProps.js';
import '../range-input/index.js';
import '../range-input/RangeInputPopup.js';
import '../range-input/style/css.js';
import '../range-input/type.js';
import '../date-picker/panel/RangePanel.js';
import '../date-picker/panel/PanelContent.js';
import '../date-picker/base/Header.js';
import '../date-picker/base/Table.js';
import '../date-picker/base/Cell.js';
import '../_common/js/date-picker/utils.js';
import '../_chunks/dep-fdce1f4f.js';
import '../_common/js/date-picker/format.js';
import '../time-picker/index.js';
import '../time-picker/TimePicker.js';
import '../time-picker/panel/TimePickerPanel.js';
import '../time-picker/panel/SinglePanel.js';
import '../time-picker/hooks/useTimePickerTextConfig.js';
import '../_common/js/time-picker/const.js';
import '../_common/js/time-picker/utils.js';
import '../hooks/useDebounce.js';
import '../hooks/usePropsRef.js';
import '../time-picker/defaultProps.js';
import '../time-picker/style/css.js';
import '../time-picker/type.js';
import '../date-picker/panel/ExtraContent.js';
import '../date-picker/base/Footer.js';
import '../date-picker/hooks/useTableData.js';
import '../date-picker/hooks/useDisableDate.js';
import '../date-picker/hooks/useRange.js';
import '../date-picker/hooks/useRangeValue.js';
import '../date-picker/defaultProps.js';

var ctrlKeyMap = /* @__PURE__ */new Map();
ctrlKeyMap.set(Checkbox, "checked");
ctrlKeyMap.set(CheckTag, "checked");
ctrlKeyMap.set(Upload, "files");
var initialDataMap = /* @__PURE__ */new Map();
[Tree, Upload, Transfer, TagInput, RangeInput, CheckboxGroup, DateRangePicker, TimeRangePicker].forEach(function (component) {
  initialDataMap.set(component, []);
});
[Checkbox].forEach(function (component) {
  initialDataMap.set(component, false);
});
function getDefaultInitialData(_ref) {
  var name = _ref.name,
    formListName = _ref.formListName,
    children = _ref.children,
    initialData = _ref.initialData,
    initialDataFromContext = _ref.initialDataFromContext;
  var defaultInitialData;
  if (initialDataFromContext) {
    if (typeof name === "string") defaultInitialData = initialDataFromContext[name];
    if (Array.isArray(name)) {
      var nameList = formListName ? [formListName].concat(_toConsumableArray(name)) : name;
      var symbol = Symbol("initialData");
      var fieldValue = null;
      for (var i = 0; i < nameList.length; i++) {
        var item = nameList[i];
        if (Reflect.has(fieldValue || initialDataFromContext, item)) {
          fieldValue = Reflect.get(fieldValue || initialDataFromContext, item);
        } else {
          fieldValue = symbol;
          break;
        }
      }
      if (fieldValue !== symbol) {
        defaultInitialData = fieldValue;
      }
    }
  }
  if (typeof initialData !== "undefined") defaultInitialData = initialData;
  React.Children.forEach(children, function (child) {
    if (child && /*#__PURE__*/React.isValidElement(child) && typeof defaultInitialData === "undefined") {
      defaultInitialData = initialDataMap.get(child.type);
    }
  });
  return defaultInitialData;
}

export { ctrlKeyMap, getDefaultInitialData, initialDataMap };
//# sourceMappingURL=useInitialData.js.map
